import React, { Component } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'

import PlaceHolder from '../../../atoms/PlaceHolder'
import ImageRatio from '../../../atoms/ImageRatio'
import { Row, Col } from '../../../atoms/Grid'

import ImageLightBox from '../../../third-party/ImageLightBox'

import style from './style.css'

export default class ListImages extends Component {
    static propTypes = {
        token: PropTypes.string.isRequired
    }

    state = {
        images: null,
        lightBox: false,
        indexImageLightBox: 0
    }

    componentWillMount() {
        axios.get('event_images/images/'+this.props.token+'/0/5')
        .then(resp => {
            this.props.handleLoaded(true)
            // if(resp.total > 0) {
            //     if(this.props.handleLoaded)
            // } else {
            //     if(this.props.handleLoaded)
            //         this.props.handleLoaded(false)
            // }

            resp.result = resp.result.map(image => {
                image = image.image_path
                return image
            })
            this.setState({
                images: resp.result
            })
        })
    }

    openImage(index) {
        this.setState({
            indexImageLightBox: index,
            lightBox: true,
        })
    }

    render() {
        let images = this.state.images
        if(images !== null && images.length === 0)
        return <span />


        return (
            <div className={style.images}>
                { images === null && (
                    <PlaceHolder type='retangle' style={{height:'250px'}} />
                )}

                { images !== null && (
                    
                    <div className={style.imagesAlbum}>
                        { images.length === 1 && (
                            <Col size='12'>
                                <Row>
                                    <div onClick={() => { this.openImage(0) }}>
                                        <ImageRatio image={images[0]} ratio='2x1' />
                                    </div>
                                </Row>
                            </Col>
                        )}
                        
                        { images.length > 1 && (
                            <Col size='6'>
                                <Row>
                                    <div onClick={() => { this.openImage(0) }}>
                                        <ImageRatio image={images[0]} />
                                    </div>
                                </Row>
                            </Col>
                        )}


                        { images.length > 1 && (
                            <Col size='6'>
                                <Row>
                                    { images.length === 2 ?
                                        (
                                            <div onClick={() => { this.openImage(1) }}>
                                                <ImageRatio image={images[1]} />
                                            </div>
                                        ) : 
                                        images.length === 3 ?
                                        (
                                            <div>
                                                <div onClick={() => { this.openImage(1) }}>
                                                    <ImageRatio image={images[1]} ratio='2x1' />
                                                </div>
                                                <div onClick={() => { this.openImage(2) }}>
                                                    <ImageRatio image={images[2]} ratio='2x1' />
                                                </div>
                                            </div>
                                        ) :
                                        images.length === 4 ?
                                        (
                                            <div>
                                                <div onClick={() => { this.openImage(1) }}>
                                                    <ImageRatio ratio='2x1' image={images[1]} />
                                                </div>
                                                <div className={style.image} onClick={() => { this.openImage(2) }}>
                                                    <ImageRatio image={images[2]} />
                                                </div>
                                                <div className={style.image} onClick={() => { this.openImage(3) }}>
                                                    <ImageRatio image={images[3]} />
                                                </div>
                                            </div>
                                        )
                                        :
                                        (
                                            <div>
                                                <div className={style.image} onClick={() => { this.openImage(1) }}>
                                                    <ImageRatio image={images[1]} 
                                                    />
                                                </div>
                                                <div className={style.image} onClick={() => { this.openImage(2) }}>
                                                    <ImageRatio image={images[2]} />
                                                </div>
                                                <div className={style.image} onClick={() => { this.openImage(3) }}>
                                                    <ImageRatio image={images[3]} />
                                                </div>
                                                <div className={style.image} onClick={() => { this.openImage(4) }}>
                                                    <ImageRatio image={images[4]} />
                                                </div>
                                            </div>
                                        )
                                    }
                                   
                                </Row>
                            </Col>
                        )}
                        <ImageLightBox handleClose={() => {
                            this.setState({
                                lightBox: false
                            })
                        }} isOpen={this.state.lightBox} images={this.state.images} photoIndex={this.state.indexImageLightBox}/>
                    </div>
                
                )}

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/templates/Event/ListImages/index.js